import { connect } from 'react-redux';

import { MainImage, IMainImageStoreProps, IMainImageOwnProps } from '../../components/MainImage';
import { IApplicationState } from '../../types/redux';

/* istanbul ignore next */
function mapStateToProps(state: IApplicationState): IMainImageStoreProps {
  return {
    page: state.page,
    user: state.user,
    total: state.results.total,
    favoriteEntities: state.results.favoriteEntities,
  };
}

export const MainImageContainer = connect<IMainImageStoreProps, {}, IMainImageOwnProps>(mapStateToProps)(MainImage);
